var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Button, LoadingButton, ModalHeader, ModalBody, ModalFooter, Typography, } from '@one-thd/sui-atomic-components';
import { ACTIONS } from '../../../models/proallowance';
import { proAllowanceApi } from '../../../api/pro-allowance';
import { ERR_GENERIC } from '../../../constants/response-error-messages';
import { track } from '../../../utils/analytics';
import { PRO_GET_POST_PAGE_ERROR, PRO_ALLOWANCE_OVERLAY, PRO_GET_ACTION_OVERLAY, } from '../../../constants/analytics';
export var ProAllowanceModal = function (_a) {
    var hideModal = _a.hideModal, action = _a.action, allowanceId = _a.allowanceId, onSuccess = _a.onSuccess, onError = _a.onError;
    var _b = __read(useState(false), 2), isLoading = _b[0], setIsLoading = _b[1];
    var closePopup = function () {
        track(PRO_GET_ACTION_OVERLAY, {
            message: "pro allowance ".concat(action.toLowerCase(), " overlay: no or X button"),
        });
        hideModal();
    };
    var handleMeatballAction = function () {
        setIsLoading(true);
        // Analytics tracking
        track(PRO_GET_ACTION_OVERLAY, {
            message: "pro allowance ".concat(action.toLowerCase(), " overlay: ").concat(action.toLowerCase(), "d allowance"),
        });
        if (action === ACTIONS.DISABLE) {
            return proAllowanceApi
                .disableAllowance({ allowanceId: allowanceId })
                .then(function () { return onSuccess(); })
                .catch(function (error) {
                var message = ERR_GENERIC.message;
                track(PRO_GET_POST_PAGE_ERROR, {
                    displayType: 'inline',
                    message: message,
                    code: error.code || '',
                    type: 'error',
                    pageSection: PRO_ALLOWANCE_OVERLAY,
                });
                onError();
            })
                .finally(function () {
                setIsLoading(false);
                hideModal();
            });
        }
        if (action === ACTIONS.DELETE) {
            return proAllowanceApi
                .deleteAllowance({ allowanceId: allowanceId })
                .then(function () { return onSuccess(); })
                .catch(function (error) {
                var message = ERR_GENERIC.message;
                track(PRO_GET_POST_PAGE_ERROR, {
                    displayType: 'inline',
                    message: message,
                    code: error.code || '',
                    type: 'error',
                    pageSection: PRO_ALLOWANCE_OVERLAY,
                });
                onError();
            })
                .finally(function () {
                setIsLoading(false);
                hideModal();
            });
        }
        return false;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: closePopup },
            "Do You Want To ",
            action,
            " This Pro Allowance?"),
        React.createElement(ModalBody, null,
            React.createElement(Typography, null, "You'll still be able to review all purchase history associated with this Pro Allowance in your account.")),
        React.createElement(ModalFooter, null,
            React.createElement("div", { className: "sui-w-full sui-flex sui-gap-3 sui-flex-col-reverse sm:sui-flex-row sui-justify-end" },
                React.createElement(Button, { variant: "secondary", onClick: closePopup }, "No"),
                React.createElement(LoadingButton, { loading: isLoading, variant: "primary", onClick: handleMeatballAction, "data-testid": { action: action }.action.toLocaleLowerCase() + '-pro-allowance-button' },
                    "Yes, ",
                    action,
                    " This Allowance")))));
};
ProAllowanceModal.displayName = 'ProAllowanceModal';
